import { MenuItemLogOutButton } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonProfile/components/MenuItemLogOutButton"
import { MenuDivider } from "@mantine/core"

export function MenuLogoutSection() {
  return (
    <>
      <MenuDivider />
      <MenuItemLogOutButton />
    </>
  )
}
